// extracted by mini-css-extract-plugin
export default {"titre_page":"titre-page_titre_page__s3doJ"};